import React from 'react';
import { ReactComponent as HeaderLogo } from 'assets/icons/logo-icons/new-cuverse-logo-white.svg';

export const OuterHeader: React.FC = () => {
  return <HeaderLogo />;
};
